import React from 'react'
import BussinessModel from './Sections/BussinessModel'

const BussinessServices = () => {
    return (
        <>
            <BussinessModel/>
        </>
    )
}

export default BussinessServices
